import { Component, Input, OnInit } from '@angular/core';
import { UserProfileConstants } from '../../user-profile/user-profile-constants';
import { UserProfile } from '../../user-profile/models/user-profile';
import { TreeNode } from 'primeng/api';
import { UserService } from '../../user-profile/user.service';

@Component({
  selector: 'app-user-profile-details',
  templateUrl: './user-profile-details.component.html',
  styleUrls: ['./user-profile-details.component.scss']
})
export class UserProfileDetailsComponent implements OnInit
{
  @Input() userProfile: UserProfile = {} as UserProfile;
  files: File[] = [];
  @Input() treeData: TreeNode[] = [];
  showConfirmationModal:boolean = false;
  confirmationMessage:string = UserProfileConstants.ConfirmationMessage;
  deleteAttachmentId:string|undefined;
  userProfileAcessErrorMessage!:string;
  notApplicableText = UserProfileConstants.NotApplicable;

  ngOnInit(): void {
  }

  constructor( private userService: UserService){
    
  }
  
  
  deleteAttachment(attachmentId:string){
    this.showConfirmationModal = true;
    this.deleteAttachmentId = attachmentId;
  }
  
  
  
  downloadAttachment = (fileId: string, fileName: string) => {
    this.userService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }


  closedConfirmation(closed:boolean){
    if(closed){
      this.showConfirmationModal = false;
    }
  }
  
  confirmDelete(confirm:boolean){
    if(confirm){
      const attachmentToDelete = this.userProfile.attachments?.find(
        (attachment) => attachment.attachmentId === this.deleteAttachmentId
      );

      if (attachmentToDelete?.attachmentFileId) {
        this.userService.deleteFile(attachmentToDelete.attachmentFileId).subscribe({
          next: () => {
            this.removeAttachmentRecord();
          },
          error: () => {
            this.removeAttachmentRecord();
          }
        });
      } else {
        this.removeAttachmentRecord();
      }

      this.showConfirmationModal = false;
    }
  }

  private removeAttachmentRecord() {
    this.userService.removeAttachment(this.userProfile.puid, this.deleteAttachmentId!).subscribe(() => {
      this.reloadAttachments();
      this.deleteAttachmentId = undefined;
    });
  }

  private reloadAttachments(){
    setTimeout(()=>{
      this.userService.getAttachmentsForUser(this.userProfile.puid).subscribe((result)=>{
        this.userProfile.attachments = result;
    })
    }, 3000);
  }

}
